import axios from 'axios';
// import { getNewToken } from './api';

const api = axios.create({
  transformRequest: [
    function (data, headers) {
      headers['Content-Type'] = 'application/json';
      if (data instanceof FormData) {
        return data;
      }
      return JSON.stringify(data);
    },
  ],
})
api.interceptors.request.use(async config => {
  config.baseURL = process.env.REACT_APP_URL_API
  config.headers = {
    'Authorization': 'Bearer ' + localStorage.getItem('token'),
  }
  return config;
},
  error => { Promise.reject(error) }
)

const responseSuccessHandler = response => {
  if (response.status === 200) return response.data
  else return { message: response.statusText }
};

const responseErrorHandler = async error => {
  // eslint-disable-next-line eqeqeq
  if (error == 'Error: Network Error') return { message: 'Could not connect to server, please try again later' }
  if (error.response?.status === 401) {
    // //uncomment this in case we want to use refresh token
    // const originalRequest = error.config
    // const {token} = await getNewToken()
    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
    // return axios.create(originalRequest)
    if (localStorage.getItem('token')) {
      localStorage.removeItem('token')
      window.location.assign('/')
    }
    return { message: error.response?.data.message }
  }
  if (error.response?.status === 403) return { message: 'Bạn không có quyền thực hiện!', code: 403 }
  if (error.response?.status === 422) return { message: Object.values(error.response.data)[0][0] }
  return { message: error.response?.data?.message, code: error.response?.status }
}

api.interceptors.response.use(
  response => responseSuccessHandler(response),
  error => responseErrorHandler(error)
);


export const HTTP = api